<div id="partCardList_div_IsNotLoading" class="w-100" [hidden]="!hasParts">
  @if (title) {
    <div class="title-of-box-hold">
      <h5 class="strong">{{title}}</h5>
    </div>
  }
  <div class="position-relative">
    <div class="related-alternate-parts-pagination">
      @if (pager.pages && pager.pages.length) {
        <nav id="partCardList_nav_Pagination" class="d-flex align-items-center" aria-label="Page navigation">
          <div>
            <span [ngClass]="{'text-light': partType === featuredProductType}" class="pagination-result">Showing {{pager.startIndex + 1}} - {{pager.endIndex + 1}} of {{pager.totalItems}} Results</span>
          </div>
          <div>
            <ul class="pagination">
              <li class="page-item" [ngClass]="{disabled:pager.currentPage == 1}">
                <a id="partCardList_a_PagePrevious" [ngClass]="{'dark': partType === featuredProductType}" class="page-link" aria-label="Previous" (click)="setPage(pager.currentPage - 1)"><span aria-hidden="true">&lsaquo;</span></a>
              </li>
              @for (page of pager.pages; track page; let i = $index) {
                <li id="partCardList_li_PageList_{{i}}" class="page-item" [ngClass]="{active:pager.currentPage == page}">
                  <a id="partCardList_a_PageItem_{{i}}" class="page-link" (click)="setPage(page)">{{page}}</a>
                </li>
              }
              <li class="page-item" [ngClass]="{disabled:pager.currentPage == pager.totalPages}">
                <a id="partCardList_a_PageNext" [ngClass]="{'dark': partType === featuredProductType}" class="page-link" aria-label="Next" (click)="setPage(pager.currentPage + 1)"><span aria-hidden="true">&rsaquo;</span></a>
              </li>
            </ul>
          </div>
        </nav>
      }
    </div>
  </div>
  <div class="p-3 bg-white">
    <div class="row">
      @for (part of pagedParts; track part; let i = $index) {
        <div class="col-12 col-md-3">
          <div>
            <part-card [index]="i" [part]="part" [isInModal]="isInModal" [displayType]="displayType" (partChange)="changeFavorite($event)" (navigateToPart)="onNavigateToPart($event)" (partAddedToRequest)="partAddedToRequest.emit($event)" [partType]="partType" [sourcePart]="sourcePart"></part-card>
          </div>
        </div>
      }
    </div>
  </div>
</div>
